import Box from '@mui/material/Box';

import { styles } from './styles';

const PaymentErrors = ({ errors }) => {
	if (errors && typeof errors === 'string') {
		return <Box sx={styles.cardError}>{errors}</Box>;
	}

	return (
		errors?.map(error => {
			return (
				<Box key={error.field} sx={styles.cardError}>
					{error?.message || error}
				</Box>
			);
		}) || null
	);
};

export default PaymentErrors;
